"use strict";

var ajaxForm = require('../../ajax-form/index');

var superAjaxForm = ajaxForm.prototype;
module.exports = ajaxForm.extend({
  showErrors: function showErrors(errors, parent) {
    superAjaxForm.showErrors.apply(this, [errors, parent]);
    this.$el.trigger('show:errors');
    this.notifications.render();
  },
  resetErrors: function resetErrors() {
    superAjaxForm.resetErrors.apply(this);
    this.notifications.render();
  },
  toggleLoading: function toggleLoading(status) {
    superAjaxForm.toggleLoading.apply(this, [status]);
    this.$el.trigger('toggle:loading', [status]);
  }
});